import React from 'react';
import { Route, useHistory, useLocation } from 'react-router-dom';
import { HelpSidecar } from '../../containers/HelpSidecar';
import { HELP_PATH_SUFFIX } from '../../routes';

const removeTrailingSlash: (path: string) => string = s => s.replace(/\/+$/, '');
const removeLastUrlComp: (path: string) => string = p => p.split('/').slice(0, -1).join('/');

interface HelpReactOverlaySidecarProps {
  onClose?: () => void;
}

export const HelpOverlayView: React.FC<HelpReactOverlaySidecarProps> = ({ onClose }) => {
  const history = useHistory();
  const location = useLocation();
  const navigateToParentPageUrl = () =>
    history.replace({
      pathname: removeLastUrlComp(removeTrailingSlash(location.pathname)),
      search: location.search,
      state: location.state,
    });

  return (
    <Route
      data-component="HelpOverlayView"
      path={`/ui/:_*/${HELP_PATH_SUFFIX}`}
      render={() => <HelpSidecar closeFn={navigateToParentPageUrl} closeAfterFn={onClose} />}
    />
  );
};
